import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TerceroRegistroComponent } from './tercero-registro.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { TerceroRegistroModalComponent } from './tercero-registro-modal/tercero-registro-modal.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDatepickerModule } from '@angular/material/datepicker';



@NgModule({
	declarations: [
		TerceroRegistroComponent,
		TerceroRegistroModalComponent,
	],
	exports: [
		TerceroRegistroComponent,
		TerceroRegistroModalComponent
	],
	imports: [
		CommonModule,
		FuseSharedModule,
		NgxMaskModule.forRoot(),
		MatToolbarModule,
		MatButtonModule,
		MatIconModule,
		MatInputModule,
		MatFormFieldModule,
		MatTooltipModule,
		MatDialogModule,
		MatSnackBarModule,
		MatTabsModule,
		MatSelectModule,
		MatRadioModule,
		MatCheckboxModule,
		MatDatepickerModule,

		MatTableModule,
		MatSortModule,
		MatPaginatorModule,

	],
})
export class TerceroRegistroModule { }
